import { IconButton } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';
import React, { FC } from 'react';

interface BackButtonProps {
  onClick: () => void;
}

const BackButton: FC<BackButtonProps> = ({ onClick, ...rest }) => {
  return (
    <IconButton sx={{ height: '3rem', width: '3rem' }} onClick={onClick} {...rest}>
      <ChevronLeft />
    </IconButton>
  );
};

export default BackButton;
